import Vue from 'vue'

import home from './services/home'    // 首页

Vue.prototype.service = {
  home
}



// WEBPACK FOOTER //
// ./src/service/index.js